import React, { Component } from "react"

import { Icon } from "@components/icon"

import * as styles from "./contact-us-box.module.css"

class ContactUsBox extends Component {
  state = {}
  render() {
    // Always render this markup so WhatConverts' Dynamic Number Insertion can
    // swap the phone number when it scans the DOM at page load. `show` only
    // toggles visibility via CSS. If we mounted conditionally (returning null
    // until the icon is clicked), the number would be absent when WhatConverts
    // runs and the click would reveal the un-swapped default number.
    return (
      <div
        className={`${styles.container} ${this.props.show ? "" : styles.hidden}`}
      >
        <div className={styles.header}>Get in Touch!</div>
        <div className={styles.buttonsWrapper}>
          <a href="tel:01283512111" className={`${styles.button} btn`}>
            <Icon id="phone" width="16" height="16" />
            <span className={styles.phoneNumber}>01283 512 111</span>
          </a>
          <a
            href="mailto: sales@firstfence.co.uk"
            className={`${styles.button} btn`}
          >
            <Icon id="envelope" width="16" height="16" />
            sales@firstfence.co.uk
          </a>
        </div>
      </div>
    )
  }
}

export default ContactUsBox
